const GoogleMapsEmbeddingName = 'Google Maps';
const RECAPTCHA_EMBEDDING = 'Google reCAPTCHA';

export { GoogleMapsEmbeddingName, RECAPTCHA_EMBEDDING };
